import { forwardRef, type InputHTMLAttributes, useId } from 'react';

export interface RadioButtonProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'id' | 'type'> {
  label: string;
  message?: string | undefined;
  invalid?: boolean;
}

/** Labelled, accessible radio input — mirrors the Checkbox API. */
export const RadioButton = forwardRef<HTMLInputElement, RadioButtonProps>(function RadioButton(
  { label, message, invalid = false, required, className, ...rest },
  ref,
) {
  const inputId = useId();
  const messageId = `${inputId}-message`;

  return (
    <div className="zs-radio">
      <div className="zs-radio__row">
        <input
          id={inputId}
          type="radio"
          ref={ref}
          className={['zs-radio__input', className].filter(Boolean).join(' ')}
          aria-invalid={invalid || undefined}
          aria-describedby={message ? messageId : undefined}
          required={required}
          {...rest}
        />
        <label className="zs-radio__label" htmlFor={inputId}>
          {label}
        </label>
      </div>
      {message ? (
        <span
          id={messageId}
          className={invalid ? 'zs-field__error' : 'zs-field__label'}
          role={invalid ? 'alert' : undefined}
        >
          {message}
        </span>
      ) : null}
    </div>
  );
});
